import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";

import {
  AddCommentTdsSignOffReportPayloadType,
  GetAllTanNumberListPayloadType,
  GetSignOffTdsReportPayloadType,
  GetTdsTcsListPayloadType,
  PostSaveTdsEntryPayloadType,
} from "@/commonTypes/TdsTcsManagementType";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function getTdsReceivableListApi(
  data: GetTdsTcsListPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear } = data;

  let finalParams = {
    client_code: clientCode,
    financial_year: financialYear,
  };
  return await getData(`invoice-generation/tds-entry/sales/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getTdsPayableListApi(
  data: GetTdsTcsListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    clientCode,
    financialYear,
    limit,
    offset,
    searchValue,
    sort_by,
    sort_order,
    supplier_id,
    tds_category,
    tds_section,
    residential_status,
    threshold_status,
    lower_deduction_certificate,
    is_tds_deducted,
    start_date,
    end_date,
  } = data;

  let finalParams = {
    client_code: clientCode,
    financial_year: financialYear,
    limit,
    offset,
    ...(searchValue && { search_value: searchValue }),
    ...(sort_by && { sort_by }),
    ...(sort_order && { sort_order }),
    ...(supplier_id !== undefined &&
      supplier_id !== null && { supplier_ledger_id: supplier_id }),
    ...(tds_category && { tds_category }),
    ...(tds_section && { tds_section }),
    ...(residential_status !== undefined &&
      residential_status !== null && { residential_status }),
    ...(threshold_status !== undefined &&
      threshold_status !== null && { threshold_status }),
    ...(lower_deduction_certificate !== undefined &&
      lower_deduction_certificate !== null && {
        lower_deduction_certificate,
      }),
    ...(is_tds_deducted !== undefined &&
      is_tds_deducted !== null && { is_tds_deducted }),
    ...(start_date && { start_date }),
    ...(end_date && { end_date }),
  };
  return await getData(`invoice-generation/tds-entry/expense/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function postSaveTdsEntryApi(
  data: PostSaveTdsEntryPayloadType
): Promise<AxiosResponse> {
  const { token, ...finalData } = data;

  return await postData(`invoice-generation/tds-entry/save`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
      "user-token": token,
    },
  });
}

export async function getSignOffTdsReportListApi(
  data: GetSignOffTdsReportPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear, month, tanNumber } = data;

  let finalParams = {
    client_code: clientCode,
    financial_year: financialYear,
    month,
    tan_number: tanNumber,
  };
  return await getData(`invoice-generation/tds-sign-off/report`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSignOffTdsReportDetailsApi(
  data: GetSignOffTdsReportPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear, month, tanNumber } = data;

  let finalParams = {
    client_code: clientCode,
    financial_year: financialYear,
    month,
    tan_number: tanNumber,
  };
  return await getData(`invoice-generation/tds-sign-off/details`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function approveTdsSignOffReportApi(
  data: GetSignOffTdsReportPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear, month, tanNumber } = data;
  let finalData = {
    client_code: clientCode,
    financial_year: financialYear,
    tan_number: tanNumber,
    month: month,
  };

  return await postData(`invoice-generation/tds-sign-off/approve`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
      "user-token": token,
    },
  });
}

export async function addCommentTdsSignOffReportApi(
  data: AddCommentTdsSignOffReportPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear, month, tanNumber, comment } = data;

  let finalData = {
    client_code: clientCode,
    financial_year: financialYear,
    tan_number: tanNumber,
    month: month,
    comment: comment,
  };

  return await postData(`invoice-generation/tds-sign-off/comment`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
      "user-token": token,
    },
  });
}

export async function signOffTdsReportApi(
  data: GetSignOffTdsReportPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, financialYear, month, tanNumber } = data;
  let finalData = {
    client_code: clientCode,
    financial_year: financialYear,
    tan_number: tanNumber,
    month: month,
  };

  return await postData(
    `/invoice-generation/tds-sign-off/sign-off`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": getCSRFToken(),
        "user-token": token,
      },
    }
  );
}

export async function getAllTanNumberListApi(
  data: GetAllTanNumberListPayloadType
): Promise<AxiosResponse> {
  const { client_code, token } = data;

  let finalParams = {
    client_code,
  };

  return getData(`invoice-generation/address/unique/tan/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
